import React from 'react';
import { LocationAddress } from './types';

const StoreAddress = ({ location }: { location: LocationAddress }) => {
  return (
    <div className="store-address-wrapper">
      <span className="alo-location-pin-icon"></span>
      <address className="store-address body small">
        {location.address1 || ''}
        {location.address2 || ''}
        <br />
        {location.city || ''}, {location.province_code || ''} {location.zip || ''}
      </address>
    </div>
  );
};

export default StoreAddress;
